import * as React from 'react';
import { observer } from 'mobx-react';

import { useChannelsModalStore } from 'stores/ChannelsModalStore';

import CreationChannel from './CreationChannel';
import Content from './Content';
import SelectedChannel from './SelectedChannel';
import Tabs from './Tabs';
import ChannelsSection from './ChannelsSection';

import './ChannelsContent.modules.scss';

type ChannelsContentProps = {
  footer?: React.ReactNode;
  className?: string;
};

const ChannelsContent: React.FC<ChannelsContentProps> = ({
  footer,
  className
}: ChannelsContentProps) => {
  const { store } = useChannelsModalStore();
  const channelListFooter = store.scenario ? footer : undefined;
  const selectedChannelFooter = store.showSelectedChannelScenarios
    ? footer
    : undefined;
  return (
    <>
      {store.withSections && (
        <div styleName="channels" className={className}>
          <CreationChannel />
          <Content styleName="channels__content" footer={channelListFooter} />
          <SelectedChannel footer={selectedChannelFooter} />
        </div>
      )}
      {!store.withSections && (
        <div styleName="channels channels_column" className={className}>
          <Tabs inModal={store.isModal} />
          <ChannelsSection styleName="channels_mobile" footer={footer} />
        </div>
      )}
    </>
  );
};

export default observer(ChannelsContent);
